import * as React from 'react';
export const vdkSvg = React.forwardRef(function vdkSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.99 17.5c-.67-.003-1.14-.502-1.136-1.205.004-.687.49-1.17 1.175-1.167.665.003 1.131.494 1.127 1.185-.005.679-.508 1.192-1.165 1.188Z',
      fill: '#EA5A0A',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M26 27 5.818 23.263A1.01 1.01 0 0 1 5 22.266V8.758c0-.507.368-.935.862-1.004L26 5c1 0 1 .373 1 .987v19.974c0 .632 0 1.04-1 1.04Zm-8.794-8.64c-.75.738-1.6.804-2.481.412-.964-.428-1.405-1.241-1.468-2.262-.077-1.221.546-2.255 1.59-2.67.66-.262 1.693-.28 2.342.453l.005-.084c.003-.054.007-.1.007-.147v-.56c0-.746.001-1.492-.009-2.238-.003-.206.262-.255.262-.255s.84.005 1.296.005v.255l-.003 1.723v.003c-.003 1.87-.006 3.74-.002 5.61.002.24-.3.289-.3.289l-.99-.001s-.278-.065-.25-.263c.007-.053.005-.108.003-.17l-.002-.1Zm5.084-3.531c.24-.289.462-.557.678-.83a.5.5 0 0 1 .443-.216c.32.01.64.008.961.006h.442c.046 0 .093.002.16.006l.14.008-2.092 2.283 1.006 1.166.005.005 1.467 1.7-.098.012a.8.8 0 0 1-.115.012h-.475a37.67 37.67 0 0 0-.951.003.414.414 0 0 1-.367-.17c-.348-.432-.7-.86-1.073-1.312l-.42-.508.001.211v.549c0 .353 0 .707-.007 1.06v.057c0 .06 0 .13-.014.13-.303.008-.648.005-.984.001L20.5 19v-7.994h.824c.15.001.3.002.45-.004.182-.008.246.064.244.258-.007.871-.008 1.743-.01 2.614l-.001 1.09v.208l.283-.342Zm-9.535-.29.245-.534h-.47c-.382.002-.744.003-1.105-.004-.172-.004-.243.057-.298.196-.19.483-.385.965-.58 1.447l-.157.386-.29.708-.125.3-.062-.143A414.781 414.781 0 0 0 8.8 14.2c-.031-.074-.111-.184-.17-.186-.424-.011-.848-.01-1.282-.01H7l.015.067c.006.029.01.05.019.07l.294.635c.629 1.36 1.257 2.72 1.894 4.077.031.066.152.13.235.135.163.008.326.007.49.006.164-.001.327-.002.49.006.199.009.286-.063.36-.225.428-.938.864-1.875 1.3-2.811l.403-.87.255-.554Z',
      fill: '#EA5A0A',
    }),
  );
});
vdkSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var vdk = {
  category: 'brand',
  colorable: false,
  name: 'vdk',
  svg: vdkSvg,
};
